import React from 'react';
import { graphql } from 'gatsby';
import * as styles from './header.module.scss';
import { HeaderDesktop } from './header-desktop';
import { HeaderMobile } from './header-mobile';
import { ButtonType, MenuItemType, PopularTopicType } from './types';

type StrapiHeader = {
  data: {
    strapiHeader: {
      menuItems: MenuItemType[];
      button: ButtonType;
      popularSearchTopics: PopularTopicType[];
    }
  };
};

const Header = ({ data }: StrapiHeader) => {
  const { menuItems, button, popularSearchTopics } = data.strapiHeader;

  return (
    <>
      <div className={styles.mobile}>
        <HeaderMobile menuItems={menuItems} button={button} popularTopics={popularSearchTopics} />
      </div>
      <div className={styles.desktop}>
        <HeaderDesktop menuItems={menuItems} button={button} popularTopics={popularSearchTopics} />
      </div>
    </>
  );
};

export default Header;

export const query = graphql`
  query {
    strapiHeader {
      menuItems {
        id
        name
        link
        sections {
          id
          title
          links {
            id
            name
            link
          }
          callToAction {
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData 
                }
              }
            }
            button {
              link
              name
            }
          }
          viewAllLink
        }
      }
      button {
        name
        link
      }
      popularSearchTopics {
        item
      }
    }
  }
`;
